const testEnv = {
  isTestMode: process.env.NODE_ENV === 'test',
  mail: 'jest-test-user',
};

export default testEnv;
